import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Modal, notification, Row, Space, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { DetailColumns } from './column'
import styles from './TIManagement.module.css'
import { AddOrEditFormDetailModal } from './addOrEditDetailModal'
import {
  getTrainingRecordListAsync,
  getTrainingRecordRemoveAsync,
} from './TIManagementSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { NavBar } from '../../../compnents/nav/NavBar'
import { useHistory, useLocation } from 'react-router-dom'

export const TIManagementDetailList = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const trainingId = location?.state?.trainingId

  const editTenantId = location?.state?.editTenantId

  const isEditFlag = location?.state?.isEditFlag

  const theme = useContext(ThemeContext)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [isEdit, setIsEdit] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [id, setId] = useState<any>()

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const getDataList = () => {
    setPageLoading(true)
    dispatch(
      getTrainingRecordListAsync({
        ...queries,
        trainingId: trainingId,
        tenantId: editTenantId,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (trainingId) {
      getDataList()
    }
  }, [queries, trainingId])

  return (
    <>
      <NavBar
        style={{ margin: '10px 20px 0 20px' }}
        where={['信息培训管理', '员工培训记录']}
        backtrace={{
          name: '单据列表',
          path: '/staffRecord',
          state: { selectKey: '1' },
          routeName: '员工档案',
        }}
      />
      <Col className={styles.contentDetail}>
        <Col
          className={styles.contentMain}
          style={{
            flex: 1,
            backgroundColor: theme.pn,
          }}
        >
          <Form
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            autoComplete='off'
          >
            <Row
              style={{ marginBottom: 10, width: '100%', height: '42px' }}
              align='middle'
              justify='space-between'
            >
              <Space
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  type='primary'
                  disabled={isEditFlag == 1 ? false : true}
                  onClick={() => {
                    setIsModalVisible(true)
                    setId('')
                    setIsEdit('')
                  }}
                >
                  新增
                </Button>
              </Space>
            </Row>
          </Form>
          <EditableList
            loading={pageLoading}
            page={{
              items: data,
              current: queries.current || 1,
              size: queries.size || 10,
              total: total,
            }}
            columns={DetailColumns((text, t: any) => {
              if (text == 'delete') {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认删除？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    dispatch(getTrainingRecordRemoveAsync(t.id))
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '删除成功',
                        })
                        getDataList()
                      })
                  },
                })
              } else if (text == 'edit') {
                setIsModalVisible(true)
                setIsEdit(t?.isEdit?.toString())
                setId(t?.id)
              }
            }, (queries.size || 10) * ((queries.current || 1) - 1))}
            onChangePage={(current: any, size: any) => {
              setQueries({
                ...queries,
                current,
                size,
              })
            }}
            onRow={(r) => ({
              onDoubleClick: () => {
                setId(r.id)
              },
            })}
          />
        </Col>
        {/* 新增或编辑 */}
        <AddOrEditFormDetailModal
          isEdit={isEdit}
          id={id}
          editTenantId={editTenantId}
          trainingId={trainingId}
          isModalVisible={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false)
            setId('')
          }}
          onOk={() => {
            setIsModalVisible(false)
            setId('')
            getDataList()
          }}
        />
      </Col>
    </>
  )
}
